<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr ">
            <h2>
                <span class="badge position-relative mr-2 fs-xl bg-none text-warning"><i class="fal fa-edit"></i></span>
                {{ __t('LIST') }} <span class="fw-300"><i>{{ __t('PRODUCTS') }}</i></span>
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed"
                        data-action="panel-fullscreen"
                        data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                </button>

                <button class="btn btn-icon btn-info  shadow-0  waves-effect waves-themed mr-2 ml-2" v-if="!is_load"
                        v-on:click="add_stop">
                    <i class="fal fa-blinds-open"></i>
                </button>
            </div>
        </div>

        <div class="panel-container show">
            <div class="panel-content">
                <div class="filter_block mb-3">
                    <filter_stop></filter_stop>
                </div>


                <b-skeleton-table
                    v-if="is_load"
                    :rows="cur_records"
                    :columns="2"
                    :hide-header="true"
                    :table-props="{ bordered: false, striped: true }"
                >
                </b-skeleton-table>


                <div class="inbox_vue_list" v-if="!is_load">

                    <div class="inb_pagi pt-4" v-if="rows.length > 0">
                        <pagination_list key="up" :total="pagination.total" :limit="pagination.limit"
                                         :current="pagination.pagesCurrent"
                                         @page-change="handlePageChange"></pagination_list>
                    </div>

                    <b-table v-if="rows.length > 0" :tbody-tr-class="rowClass" striped
                             class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Work...</strong>
                            </div>
                        </template>

                        <!-- header fields -->
                        <template v-slot:head(id)="data">
                            <div class="custom-control custom-checkbox">
                                <input :disabled="true"
                                       v-model="is_check_all"
                                       type="checkbox"
                                       v-on:click="check_all"
                                       class="custom-control-input"
                                       id="imc_checker_all"/>
                                <label class="custom-control-label cursor-pointer bolder" for="imc_checker_all"></label>
                            </div>
                        </template>

                        <template v-slot:head(provider)="data">
                            <div class="status_info" style="max-width: 50px">
                                {{ __t('O_EXP_IC') }}
                            </div>
                        </template>

                        <template v-slot:head(filename)="data">
                            <div class="fs-xl text-left" v-html="data.label"></div>
                        </template>

                        <template v-slot:head(title)="data">
                            <grid_list
                                :list_ordering="'ksenmart_products.title'"
                                :field_name="__t('TITLE')"
                                :current_ordering="list.ordering"
                                :current_direction="list.direction"
                                @update-order="handleOrdering"
                            />
                        </template>

                        <template v-slot:head(rest_id)="data">
                            <grid_list
                                :list_ordering="'rest_id'"
                                :field_name="__t('ATTACHED_RESTAURANT')"
                                :current_ordering="list.ordering"
                                :current_direction="list.direction"
                                @update-order="handleOrdering"
                            />
                        </template>

                        <template v-slot:head(location)="data">
                            <grid_list
                                :list_ordering="'ksenmart_products_black_listed.rest_id'"
                                :field_name="__t('ATTACHED_LOCATION')"
                                :current_ordering="list.ordering"
                                :current_direction="list.direction"
                                @update-order="handleOrdering"
                            />
                        </template>

                        <template v-slot:head(added)="data">
                            <grid_list
                                :list_ordering="'added'"
                                :field_name="__t('ADDED')"
                                :current_ordering="list.ordering"
                                :current_direction="list.direction"
                                @update-order="handleOrdering"
                            />
                        </template>

                        <template v-slot:head(client_id)="data">
                            <div class="fs-xl text-center" v-html="data.label"></div>
                        </template>
                        <!-- body -->

                        <template v-slot:cell(id)="data">
                            <div class="custom-control custom-checkbox">
                                <input
                                    v-model="data.item.published"
                                    :name="'cid[]'"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="data.item.id + '_cust_id'"/>

                                <label class="custom-control-label cursor-pointer bolder"
                                       :for="data.item.id + '_cust_id'"></label>
                            </div>
                        </template>

                        <template v-slot:cell(filename)="data">
                            <div class="img_block  rounded">
                                <picture v-if="obj_to_null(data.item.image)">
                                    <source :srcset="data.item.image.webp" type="image/webp">
                                    <source :srcset="data.item.image.jpeg" type="image/jpeg">
                                    <img itemprop="image" :src="data.item.image.jpeg">
                                </picture>
                            </div>
                        </template>


                        <template v-slot:cell(provider)="data">
                            <div class="provider_img" v-if="obj_to_null(data.item.aggregator)">
                                <div class="icon">
                                    <i class="fal fa fa-file-o fa-file"
                                       v-if="!obj_to_null(data.item.aggregator.icon)"></i>
                                    <span class="order_prov_image" v-if="obj_to_null(data.item.aggregator.icon)"
                                          v-html="data.item.aggregator.icon"></span>
                                </div>
                            </div>

                            <aggregator-icons v-if="data.item.hasOwnProperty('aggregators')"
                                              :aggregators="data.item.aggregators"/>
                        </template>

                        <template v-slot:cell(title)="data">
                            <div class="">
                                <div class="d-flex flex-start w-100 fs-xl mb-2">
                                    <div class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer"
                                         v-on:click="open_item(data)">
                                        <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                        <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                    </div>
                                    <span v-if="obj_to_null(data.item.product)">
                                         {{ data.item.product.title }}
                                    </span>
                                    <span v-else>
                                        NOT_FOUND
                                    </span>
                                </div>

                                <div class="d-flex flex-start w-100">
                                    <div class="small badge border border-success"
                                         v-if="data.item.hasOwnProperty('aggregator')">
                                        {{ data.item.aggregator.type }}
                                    </div>

                                    <div class="small badge border border-info" v-if="obj_to_null(data.item)">
                                        <span v-if="data.item.is_prod">{{ __t('CATEG:') }}</span>
                                        <span v-else>{{ __t('GROUP:') }}</span>

                                        {{ data.item.main_category.title }}
                                    </div>

                                    <div class="ml-3 small badge border border-info" v-if="obj_to_null(data.item)">
                                        {{ data.item.product_uniq }}
                                    </div>

                                    <div class="ml-3 small badge border border-warning"
                                         v-if="data.item.hasOwnProperty('restaurant')">
                                        {{ data.item.restaurant.title }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-slot:cell(rest_id)="data">
                            <div class="prod_name  fs-xl color-success-600"
                                 v-if="data.item.hasOwnProperty('restaurant')">
                                <span>
                                     {{ data.item.restaurant.title }}
                                </span>
                                <div class="small text-info">
                                    <div class="small badge border border-warning">
                                        {{ data.item.restaurant.uniq_id }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-slot:cell(location)="data">
                            <div class="prod_name  fs-xl" v-if="data.item.hasOwnProperty('location')">
                                <span>
                                     {{ data.item.location.title }}
                                </span>
                                <div class="small text-info">
                                    <div class="small badge border border-warning">
                                        {{ data.item.location.uniq_id }}
                                    </div>
                                </div>
                            </div>

                        </template>

                        <template v-slot:cell(added)="data">
                            {{ data.item.added }}
                        </template>

                        <template v-slot:cell(client_id)="data">
                            <span class="fs-xl cursor-pointer" v-on:click="remove_stop(data.item)">
                                <i class="fas fa-trash"></i>
                            </span>
                        </template>


                        <template v-slot:row-details="row">
                            <div class="stop_info">
                                <StopItemInfo @remove_stop="remove_stop" :item="row.item"></StopItemInfo>
                            </div>
                        </template>


                    </b-table>

                    <div class="inb_pagi pt-4" v-if="rows.length > 0">
                        <pagination_list
                            key="down"
                            :total="pagination.total"
                            :limit="pagination.limit"
                            :current="pagination.pagesCurrent"
                            @page-change="handlePageChange">
                        </pagination_list>
                    </div>
                </div>
            </div>

            <div
                class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex">
                <button class="btn btn-warning  shadow-0  waves-effect waves-themed mr-2 ml-2"
                        v-on:click="refresh_stop">
                    Syrve Stop Sync
                </button>
            </div>
        </div>
        <add_stop></add_stop>
    </div>
</template>

<script>
import filter_stop from "./filter/filter_stop";
import {mapGetters} from "vuex";
import add_stop from "./add/add_stop";
import AggregatorIcons from "./helpers/AggregatorIcons.vue";

import Grid_list from "../../sys/list/grid_list.vue";
import Pagination_list from "../../sys/list/pagination_list.vue";
import StopItemInfo from "./helpers/StopItemInfo.vue";

export default {
    name: "stop_list",
    components: {
        StopItemInfo,
        Pagination_list,
        Grid_list,
        AggregatorIcons,
        filter_stop,
        add_stop
    },
    data() {
        return {
            rows: [],
            is_load: true,
            is_check_all: false,
            cur_records: 35,
            fields: [
                //   { key: 'id', label: '', class: 'text-center' },
                {key: 'provider', label: '', class: 'text-left m_width_50'},
                {key: 'filename', label: '<i class="fas fa-photo-video"></i>', class: 'text-center'},
                {key: 'title', label: 'p.title', class: ''},
                //    { key: 'rest_id', label: 'b.rest_id', class: '' },
                //    { key: 'location', label: 'loc_id', class: '' },
                {key: 'added', label: 'added', class: ''},
                {key: 'client_id', label: '<i class="fal fa-cog width-2"></i>', class: ''}
            ],

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            list: {
                direction: "DESC",
                ordering: "added",
                start: 0
            },

            filter: {
                search: "",
                location_id: 0,
                provider_id: 0,
                rest_id: 0,
                location_ids: []
            }
        };
    },
    props: {
        current_state: {
            type: Object
        }
    },

    created() {
        EventBus.$on("search_stop_called", this.search_work);
        EventBus.$on("stop_reload_items", this.load_items);
        EventBus.$on("filter_stop_change", this.filter_select);
        EventBus.$on("clean_stop_filter", this.clean_stop_filter);
        EventBus.$on("reload_products", this.load_items);
    },

    mounted() {
        this.load_items();
    },

    methods: {

        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/stop_list/grouped', {
                list: this.list,
                filter: this.filter
            }).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.rows = data.data;

                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },

        async refresh_stop() {
            this.is_load = true;
            await api.patch('/internal/v1/catalog/stop_list/sync').then(() => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: "", type: "success", title: "OK"});
            })
            .catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },

        add_stop() {
            EventBus.$emit('add_stop');
        },

        open_item(row) {

            let inside_item = row.item;
            let is_grouped = inside_item.is_grouped;
            if (is_grouped) {
                let locations_count = inside_item.locations.length;
                if (locations_count > 1) {

                }
            }

            row._showDetails = !row._showDetails;
            row.toggleDetails();
        },

        check_all() {
            // handle check all
        },

        async remove_stop(black_record) {
            this.is_load = true;

            let is_group = black_record.is_grouped;
            if (is_group) {
                let item_uniq_id = black_record.product.uniq_id;

                black_record.locations.map(item => {
                    this.black_task(item_uniq_id, item);
                });
            } else {

                this.black_task(black_record.product_uniq, black_record.location.id);
            }
        },

        async black_task(item_uniq_id, loc_id) {

            const active_products = [{
                uniq_id: item_uniq_id,
                amount: 0,
                action: "remove"
            }];

            console.log(active_products);
            this.is_load = true;

            await agr_api.post(`locations/${loc_id}/stop_list/remove`, {
                products: active_products
            }).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    /*EventBus.$emit('show_toast', {
                        err: this.__t('OPERATION_SET_WORK'),
                        type: "success",
                        title: this.__t('OPERATION_SET_WORK'),
                        position: 'b-toaster-top-left'
                    });*/

                    this.load_items();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position: 'b-toaster-top-left'
                });
            });
        },


        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },

        clean_stop_filter() {

            this.filter = {
                search: "",
                location_id: 0,
                provider_id: 0,
                rest_id: 0,
                location_ids: []
            };

            this.list = {
                direction: "DESC",
                ordering: "added",
                start: 0
            };
            this.load_items();
        },

        rowClass(item) {
            return item?.class;
        },
    },
    computed: {
        ...mapGetters({
            user: "user/getUser"
        })
    }
}
</script>

<style scoped>
.img_block img,
.img_block picture {
    width: 100%;
}

.img_block {
    width: 75px;
    height: 75px;
}
</style>
